import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import {
  getIdVarificationURL,
  getInvoiceDetailsURL,
  getOwnerPropertyAddressURL,
  getQuoteUserURL,
  getRegisterPpsrCorporateURL,
  getRegisterPpsrRegisterCorporateURL,
  getUserAddressURL,
  getCreditAvailabilityFundingURL,
  getUserIdentificationURL,
  getUserManagementIdentificationURL,
  getUsersPPSRURL,
  getIndustryTypesURL,
  getCommentUrl,
  getPopupCommentsUrl
} from "../utils/constants/apiEndPoints";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import { commonErrMsg } from "../locales/en";

const initialState = {
  ppsrLoading: false,
  idCheckVarificationLoading: false,
  idCheckVarificationData: [],
  creditScoreFundData: null,
  sbmittedDataLoading: false,
  allInvDataLoading: false,
  allPpsrData: null,
  trustCorporatePpsrData: [],
  trustCorporatePpsrLoading: false,
  userIdentificationData: {},
  trustCorporateData: [],
  trustCorporateLoading: false,
  industryTypes: [],
  industryTypesLoading: false,
  popUpCommentLoading: false,
  refreshPopupCommentsFlag: false,
  refreshClientsCommentsFlag: false
};

const clientDetailsTabSlice = createSlice({
  name: "clientDetailsTab",
  initialState,
  reducers: {
    setPpsrLoading(state, action) {
      state.ppsrLoading = action.payload;
    },
    setAllPpsrData(state, action) {
      state.allPpsrData = action.payload;
    },
    setTrustCorporateData(state, action) {
      state.trustCorporateData = action.payload;
    },
    updateTrustCorporateEntityName(state, action) {
      const { id, entityName } = action.payload;
      const item = state.trustCorporateData.find((item) => item.id === id);
      if (item) {
        item.entityName = entityName;
      }
    },
    addTrustCorporateData(state, action) {
      state.trustCorporateData.push(action.payload);
    },
    removeTrustCorporateData(state, action) {
      const id = action.payload;
      state.trustCorporateData = state.trustCorporateData.filter(
        (item) => item.id !== id
      );
    },

    refreshPopupComments(state) {
      state.refreshPopupCommentsFlag = !state.refreshPopupCommentsFlag;
    },

    refreshClientsComments(state) {
      state.refreshClientsCommentsFlag = !state.refreshClientsCommentsFlag;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPPSRData.pending, (state) => {
        state.ppsrLoading = true;
      })
      .addCase(fetchUserPPSRData.fulfilled, (state) => {
        state.ppsrLoading = false;
      })
      .addCase(fetchUserPPSRData.rejected, (state, action) => {
        state.ppsrLoading = false;
        if (action.payload.status === 404) {
          showToast(action.payload.data.message, showToastType.error);
        }
      })

      .addCase(fetchTrustCorporatePPSRData.pending, (state) => {
        state.trustCorporatePpsrLoading = true;
      })
      .addCase(fetchTrustCorporatePPSRData.fulfilled, (state, action) => {
        state.trustCorporatePpsrLoading = false;
        const newData = action.payload?.data?.data || [];

        if (!Array.isArray(newData)) return;

        newData.forEach((newItem) => {
          const existingIndex = state.trustCorporatePpsrData.findIndex(
            (item) =>
              item.trustCorporateId === newItem.trustCorporateId &&
              item.corporateTrustAssociateId ===
                newItem.corporateTrustAssociateId
          );

          if (existingIndex !== -1) {
            state.trustCorporatePpsrData[existingIndex] = {
              ...state.trustCorporatePpsrData[existingIndex],
              ...newItem
            };
          } else {
            state.trustCorporatePpsrData.push(newItem);
          }
        });
      })
      .addCase(fetchTrustCorporatePPSRData.rejected, (state, action) => {
        state.trustCorporatePpsrLoading = false;
        if (action.payload.status === 404) {
          showToast(action.payload.data.message, showToastType.error);
        }
      })

      .addCase(fetchOnlyCorporatePPSRData.pending, (state) => {
        state.trustCorporatePpsrLoading = true;
      })
      .addCase(fetchOnlyCorporatePPSRData.fulfilled, (state, action) => {
        state.trustCorporatePpsrLoading = false;
        const newData = action.payload?.data?.data || [];

        if (!Array.isArray(newData)) return;

        newData.forEach((newItem) => {
          const existingIndex = state.trustCorporatePpsrData.findIndex(
            (item) =>
              item.trustCorporateId === newItem.trustCorporateId &&
              item.corporateTrustAssociateId ===
                newItem.corporateTrustAssociateId
          );

          if (existingIndex !== -1) {
            state.trustCorporatePpsrData[existingIndex] = {
              ...state.trustCorporatePpsrData[existingIndex],
              ...newItem
            };
          } else {
            state.trustCorporatePpsrData.push(newItem);
          }
        });
      })
      .addCase(fetchOnlyCorporatePPSRData.rejected, (state, action) => {
        state.trustCorporatePpsrLoading = false;
        if (action.payload.status === 404) {
          showToast(action.payload.data.message, showToastType.error);
        }
      })

      .addCase(fetchUserIdVarificationCheckData.pending, (state) => {
        state.idCheckVarificationLoading = true;
      })
      .addCase(fetchUserIdVarificationCheckData.fulfilled, (state, action) => {
        state.idCheckVarificationLoading = false;
        state.idCheckVarificationData =
          action?.payload?.data?.data?.aplyIdInfoData || [];
      })
      .addCase(fetchUserIdVarificationCheckData.rejected, (state) => {
        state.idCheckVarificationLoading = false;
      })

      .addCase(fetchUserCreditScoreFundData.fulfilled, (state, action) => {
        state.creditScoreFundData = action?.payload?.data?.data || null;
      })

      .addCase(fetchUserSubmittedInvoiceData.pending, (state) => {
        state.sbmittedDataLoading = true;
      })
      .addCase(fetchUserSubmittedInvoiceData.fulfilled, (state) => {
        state.sbmittedDataLoading = false;
      })
      .addCase(fetchUserSubmittedInvoiceData.rejected, (state, action) => {
        state.sbmittedDataLoading = false;
        const response = action.payload;
        if (response.status === 404) {
          showToast(
            response?.data?.message || commonErrMsg?.item2,
            showToastType.error
          );
        }
      })

      .addCase(fetchUserAllInvoiceData.pending, (state) => {
        state.allInvDataLoading = true;
      })
      .addCase(fetchUserAllInvoiceData.fulfilled, (state) => {
        state.allInvDataLoading = false;
      })
      .addCase(fetchUserAllInvoiceData.rejected, (state) => {
        state.allInvDataLoading = false;
      })

      .addCase(fetchNewIdentificationData.fulfilled, (state, action) => {
        const userId = action.meta.arg;
        state.userIdentificationData = {
          ...state.userIdentificationData,
          [userId]: action?.payload?.data?.data || null
        };
      })

      .addCase(fetchIndustryTypeData.pending, (state) => {
        state.industryTypesLoading = true;
      })
      .addCase(fetchIndustryTypeData.fulfilled, (state, action) => {
        state.industryTypesLoading = false;
        state.industryTypes = action?.payload?.data;
      })
      .addCase(fetchIndustryTypeData.rejected, (state) => {
        state.industryTypesLoading = false;
      })

      .addCase(fetchPopUpCommentData.pending, (state) => {
        state.popUpCommentLoading = true;
      })
      .addCase(fetchPopUpCommentData.fulfilled, (state) => {
        state.popUpCommentLoading = false;
      })
      .addCase(fetchPopUpCommentData.rejected, (state) => {
        state.popUpCommentLoading = false;
      });
  }
});

export const fetchUserPPSRData = createAsyncThunk(
  "clientDetailsTab/fetchUserPPSRData",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await privateAxios.get(getUsersPPSRURL(payload));
      dispatch(setAllPpsrData(response?.data?.data));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchTrustCorporatePPSRData = createAsyncThunk(
  "clientDetailsTab/fetchTrustCorporatePPSRData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getRegisterPpsrCorporateURL(
          payload.id,
          payload.tabIndex,
          payload.associateId
        )
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchOnlyCorporatePPSRData = createAsyncThunk(
  "clientDetailsTab/fetchOnlyCorporatePPSRData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getRegisterPpsrRegisterCorporateURL(payload.id, payload.tabIndex)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchUserIdentificationData = createAsyncThunk(
  "clientDetailsTab/fetchUserIdentificationData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getUserIdentificationURL(payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchNewIdentificationData = createAsyncThunk(
  "clientDetailsTab/fetchNewIdentificationData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getUserManagementIdentificationURL(payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchUserAddressData = createAsyncThunk(
  "clientDetailsTab/fetchUserAddressData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getUserAddressURL(payload));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchUserCreditScoreFundData = createAsyncThunk(
  "clientDetailsTab/fetchUserCreditScoreFundData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getCreditAvailabilityFundingURL, {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchUserPropertyAddressData = createAsyncThunk(
  "clientDetailsTab/fetchUserPropertyAddressData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(
        getOwnerPropertyAddressURL(payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchUserIdVarificationCheckData = createAsyncThunk(
  "clientDetailsTab/fetchUserIdVarificationCheckData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await privateAxios.put(getIdVarificationURL(payload));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchUserSubmittedInvoiceData = createAsyncThunk(
  "clientDetailsTab/fetchUserSubmittedInvoiceData",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getQuoteUserURL(id), {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchUserAllInvoiceData = createAsyncThunk(
  "clientDetailsTab/fetchUserAllInvoiceData",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getInvoiceDetailsURL(id), {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchIndustryTypeData = createAsyncThunk(
  "clientDetailsTab/fetchIndustryTypeData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getIndustryTypesURL);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchPopUpCommentData = createAsyncThunk(
  "clientDetailsTab/fetchPopUpCommentData",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getCommentUrl(id), {
        params: payload
      });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchCustomerCommentData = createAsyncThunk(
  "clientDetailsTab/fetchCustomerCommentData",
  async ({ payload }, { rejectWithValue }) => {
    try {
      const response = await privateAxios.get(getPopupCommentsUrl(payload));
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const {
  setAllPpsrData,
  setTrustCorporateData,
  updateTrustCorporateEntityName,
  addTrustCorporateData,
  removeTrustCorporateData,
  refreshPopupComments,
  refreshClientsComments
} = clientDetailsTabSlice.actions;
export default clientDetailsTabSlice.reducer;
